export default {
    SET_DETECTED_TIMEZONE(state, tzId) {
        state.detectedTimezone = tzId;
    },
};
